export default __webpack_public_path__ + "static/media/about_us_img.293ebd21.jpg";